import util from '@bmp-vue/core/api/util'
const controller = 'Finanfast'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  CarregaDiasAcrescimo (th, value) {
    th.model.nroDiasAcrescimoPrimPagto = th.$api.UI.Date.DaysBetween(th.$api.UI.Date.AddMonth(new Date(), 1), value)
  },
})
